import { logError } from 'utils/helpers';
import { MembershipPromo, Promo } from 'utils/helpers/activePromoHelpers';

import { StoreApi } from './instances';

export const getAdvertisedPromos = async () => {
  try {
    const promo = await StoreApi.get<Promo[]>('/v1/promotions.json');
    return promo.data;
  } catch (error) {
    logError('Failed to fetch advertised promos', {
      component: 'promosApi',
      function: 'getAdvertisedPromos',
      stackTrace: error,
    });
    return [];
  }
};
// Endpoint for membership promo codes
export const getMembershipPromoCode = async (data: MembershipPromo) => {
  const membershipPromo = await StoreApi.get<MembershipPromo>(
    `/v3/memberships/everlywell-plus-membership-1-year/promos/${data.promotion_code}`,
  );
  return membershipPromo.data;
};
